import React, { useEffect, useState, useContext } from 'react';
import AuthContext from '../AuthContext';

const Avatar = () => {
  const auth = useContext(AuthContext);
  const colors = [
    'bg-red-600',
    'bg-blue-600',
    'bg-green-500',
    'bg-yellow-500',
    'bg-teal-500',
    'bg-purple-500',
    'bg-pink-500',
    'bg-indigo-500',
  ];
  const details=localStorage.getItem('User')
  const getInitial = (name) => name.charAt(0).toUpperCase();
const id=auth.user
  const getStoredColor = (id) => {
    const storedColor = localStorage.getItem(`avatarColor-${auth.user}`);
    if (storedColor) {
      return storedColor;
    } else {
      const color = colors[Math.floor(Math.random() * colors.length)];
      localStorage.setItem(`avatarColor-${auth.user}`, color);
      return color;
    }
  };

  const [color, setColor] = useState(() => getStoredColor(auth.user));

  useEffect(() => {
    if (!details) {
      localStorage.removeItem(`avatarColor-${auth.user}`);
      setColor(null);  // Clear the color in the component state
    }
  }, [details,auth.user]);

  // Optionally return a default avatar when color is cleared
  if (!color) {
    return <div className="h-8 w-8 bg-blue-500 text-white flex items-center justify-center rounded-full">{getInitial(auth.userType)}</div>;
  }

  return (
    <div
      className={`h-8 w-8 ml-2 ${color} text-white flex items-center justify-center rounded-full`}
    >
      {getInitial(auth.userType)}
    </div>
  );
};

export default Avatar;
